import {createApp} from "vue";
import router from "./router/index.js";
import VueGtag from "vue-gtag";
import store from "./store/index.js";
import App from "./App.vue";
import "@/styles/global.css";
import metaPixel from "./plugins/meta-pixel.js";
import {createClerkPlugin} from "./plugins/clerk.js";
import {handleClerkSync} from "./plugins/clerkSessionSync.js";
import externalLinks from "./plugins/externalLinks.js"; // links to other sites open in a new tab
import errorReporter from "./plugins/errorReporter.js"; // errors to the fullstack's Monitor
import campaignCookie from "./plugins/campaignCookie.js"; // an email's campaign, for registering
import presenceTouch from "./plugins/presenceTouch.js"; // activity, for the attendee directory
import {getGaPageLocation, getGaPageView} from "@/composables/gaLocation";

//import history from "connect-history-api-fallback"; // fixes GitHub 404 issue
// `https://github.com/bripkens/connect-history-api-fallback`

// console.log(`main.js: routes = ${JSON.stringify(router.getRoutes())}`);

const app = createApp(App);
app.use(errorReporter); // first: errors while the rest starts are reported too
app.use(campaignCookie); // before the router tidies the address
app.use(presenceTouch);

// app.config.warnHandler = (msg, vm, trace) => {
//   if (msg.includes("onMounted is called")) {
//     console.warn("[Vue warn] Caught onMounted misuse:", msg);
//     console.trace(); // shows the exact source
//   }
// };

// Google Analytics on the live site only (Seán, 2026-10-23): localhost and staging sent hits to
// the same property, test runs included
const isLiveSite = ["vizbi.org", "www.vizbi.org"].includes(window.location.hostname);

app.use(router).use(createClerkPlugin());
if (isLiveSite) {
  app.use(
    VueGtag,
    {
      config: {
        id: "G-LH4WMEWL53",
        params: {
          cookie_flags: "SameSite=None;Secure",
          cookie_domain: "auto",
          page_location: getGaPageLocation() // never the hash: gaLocation.js
        }
        // https://www.tinstar.co.uk/studio-blog/some-cookies-are-misusing-the-recommended-samesite-attribute-how-to-fix/
      },
      pageTrackerTemplate: getGaPageView // never the hash (an email's address, a sign-in ticket)
    },
    router
  );
}
app
  .use(metaPixel, {pixelId: "3564078550405231"})
  .use(store)
  .use(externalLinks)
  .mount("#app");

handleClerkSync(); // staging: the fullstack asked for this site's session (#clerk-sync)
